/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CategoryListSub from './CategoryListSub';

/**
 * The CategoryListLnb model module.
 * @module model/CategoryListLnb
 * @version 1.0
 */
class CategoryListLnb {
    /**
     * Constructs a new <code>CategoryListLnb</code>.
     * @alias module:model/CategoryListLnb
     */
    constructor() { 
        
        CategoryListLnb.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CategoryListLnb</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CategoryListLnb} obj Optional instance to populate.
     * @return {module:model/CategoryListLnb} The populated <code>CategoryListLnb</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CategoryListLnb();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('lnbNo')) {
                obj['lnbNo'] = ApiClient.convertToType(data['lnbNo'], 'Number');
            }
            if (data.hasOwnProperty('pageUrl')) {
                obj['pageUrl'] = ApiClient.convertToType(data['pageUrl'], 'String');
            }
            if (data.hasOwnProperty('readonly')) {
                obj['readonly'] = ApiClient.convertToType(data['readonly'], 'Boolean');
            }
            if (data.hasOwnProperty('key')) {
                obj['key'] = ApiClient.convertToType(data['key'], 'String');
            }
            if (data.hasOwnProperty('subList')) {
                obj['subList'] = ApiClient.convertToType(data['subList'], [CategoryListSub]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CategoryListLnb</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CategoryListLnb</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['pageUrl'] && !(typeof data['pageUrl'] === 'string' || data['pageUrl'] instanceof String)) {
            throw new Error("Expected the field `pageUrl` to be a primitive type in the JSON string but got " + data['pageUrl']);
        }
        // ensure the json data is a string
        if (data['key'] && !(typeof data['key'] === 'string' || data['key'] instanceof String)) {
            throw new Error("Expected the field `key` to be a primitive type in the JSON string but got " + data['key']);
        }
        if (data['subList']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['subList'])) {
                throw new Error("Expected the field `subList` to be an array in the JSON data but got " + data['subList']);
            }
            // validate the optional field `subList` (array)
            for (const item of data['subList']) {
                CategoryListSub.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {String} name
 */
CategoryListLnb.prototype['name'] = undefined;

/**
 * @member {Number} lnbNo
 */
CategoryListLnb.prototype['lnbNo'] = undefined;

/**
 * @member {String} pageUrl
 */
CategoryListLnb.prototype['pageUrl'] = undefined;

/**
 * @member {Boolean} readonly
 */
CategoryListLnb.prototype['readonly'] = undefined;

/**
 * @member {String} key
 */
CategoryListLnb.prototype['key'] = undefined;

/**
 * @member {Array.<module:model/CategoryListSub>} subList
 */
CategoryListLnb.prototype['subList'] = undefined;






export default CategoryListLnb;

